
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
//import { GET_STATISTICS_ACCOUNT_EXCEL_API_URL, GET_STATISTICS_ACTUALIZATION_HOUSE_API_URL, GET_STATISTICS_CABLE_ACCOUNT_API_URL, GET_STATISTICS_CABLE_CANTON_API_URL, GET_STATISTICS_CABLE_EXCEL_API_URL, GET_STATISTICS_INFRASTRUCTURE_ACCOUNT_API_URL } from './OpticApiConfig';
import Select from 'react-select';
import { saveAs } from "file-saver";
import { loadingCanton, loadingRegionsData } from '../Optics/LoadingData/LoadingDataTerritory';
import { DELETE_PROJECT_API_URL, GET_PROJECTS_API_URL, POST_NEW_PROJECT_API_URL } from '../Optics/OpticApiConfig';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import ConfirmDialog from './Modals/ConfirmDialog';


//#region STYLE
const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '16px',
    border: '1px solid #ffffff',
    
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};
//#endregion 

const ProjectConstructor = (user) => 
  {

    
const [open, setOpen] = useState(false);
 const [confirmOpen, setConfirmOpen] = useState(false);
 const [projectIdToDelete, setProjectIdToDelete] = useState(null);


  const [selectedCanton, setSelectedCanton] = useState('');
  const [selectedRegion, setSelectedRegion] = useState();
  const [regions, setRegions] = useState([]);
  
  const token = localStorage.getItem('token');
  const [canton, setCanton] = useState([]);
  const [projectName, setProjectName] = useState('');
  const [projects, setProjects] = useState([]);

  useEffect(() => {
  fetch(`${GET_PROJECTS_API_URL}?authorId=${user.user}`, {
    method: 'GET',
    headers: {
      'Authorization': 'Bearer ' + token// если используешь токен
    }
  })
    .then(response => response.json())
    .then(data => setProjects(data))
    .catch(error => console.error('Ошибка при загрузке проектов:', error));
    
}, []);

   useEffect(() => {
        loadingCanton(setCanton); 
      }, []); 
  
       // ⬇️ При изменении selectedCanton — загружаем регионы
  useEffect(() => {
    const fetchRegions = async () => {
      if (selectedCanton) {
        const regionsData = await loadingRegionsData(selectedCanton);
        if (regionsData) {
          setRegions(regionsData);
        }
      } else {
        setRegions([]); // если canton не выбран — очищаем регионы
      }
    };

    fetchRegions();
  }, [selectedCanton]);
    
 const handleCreate = async () => {
  if (!projectName.trim() || !selectedCanton) {
   // alert('Пожалуйста, заполните название проекта и выберите округ.');
     setOpen(true);
    return;
  }

  try {
    const token = localStorage.getItem('token'); // или откуда вы берете токен

    const response = await fetch(`${POST_NEW_PROJECT_API_URL}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        name: projectName.trim(),
        canton: selectedCanton,
        region: selectedRegion,
        authorId: user.user, // замените на реальный ID пользователя
        date: null // сервер сам установит дату
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText);
    }

    const savedProject = await response.json();

    // Добавляем в таблицу
    setProjects([...projects, {
      id: savedProject.id,  
      name: savedProject.name,
      canton: savedProject.canton,
      region: savedProject.region,
      authorId: savedProject.authorId,
      createDate: savedProject.createDate,
    }]);

    setProjectName('');
    setSelectedCanton(null);
  } catch (error) {
    console.error('Ошибка при создании проекта:', error.message);
    console.log('Не удалось создать проект. Подробнее в консоли.');
  }
};

  const handleDeleteClick = (id) => {
    setProjectIdToDelete(id);
    setConfirmOpen(true);
  };

const handleDeleteProject = async () => {
  // if (!window.confirm("Вы уверены, что хотите удалить этот проект?")) return;
  setConfirmOpen(false);

  try {
   
    const response = await fetch(`${DELETE_PROJECT_API_URL}${projectIdToDelete}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(user.user)  // передаем имя пользователя в теле запроса
    });

    if (response.ok) {
      setProjects(projects.filter(p => p.id !== projectIdToDelete));  // обновляем список проектов после удаления
    } else if (response.status === 403) {
      console.log("Вы не являетесь автором этого проекта");
    } else {
      console.log("Ошибка при удалении проекта");
    }
  } catch (error) {
    console.error("Ошибка:", error);
  }
};

  const navigate = useNavigate();

  // ...
  // const openMapProject = (project) => {
  //   navigate('/constructionmap', { state: { project, user } }); // <-- передаём данные
  // };
 const openMapProject = (project) => {
  const projectKey = `project_${Date.now()}`; // уникальный ключ
  sessionStorage.setItem(projectKey, JSON.stringify(project));
  const url = `/constructionmap#${projectKey}`;
  window.open(url, '_blank');
};

  return (
   <div style={{display: 'flex', gap: '30px', alignItems: 'flex-start' }} >
      {/* Первый блок: Форма */}
      <div className='divConst'>
        <label className='textTitleDrawer' style={{ fontSize: "16px" }}>Новый проект</label>
        <hr className="horizontalLineDrawer" style={{ marginTop: "5px" }} />
        <input
          className='textInputEditingModal'
          style={{ width: '200px', display: 'block', marginBottom: '10px', marginLeft: "0px" }}
          placeholder='Название проекта'
          value={projectName}
          onChange={(e) => setProjectName(e.target.value)}
        />
        <Select
          className="selectSearchDrawer"
          options={canton.map(option => ({ value: option, label: option }))}
          isSearchable={true}
          styles={customStyles}
          placeholder="Округ"
          value={selectedCanton ? { value: selectedCanton, label: selectedCanton } : null}
          onChange={(selectedOption) => setSelectedCanton(selectedOption.value)}
        />

         <select
            className="selectStyleDrawer"
            style={{ marginBottom: "5px" }}
            value={selectedRegion || "null"} // контролируемое значение
            onChange={(e) => setSelectedRegion(e.target.value)}
          >
            <option value="null">Регион</option>
            {regions.map((region, index) => (
              <option key={index} value={region}>
                {region}
              </option>
            ))}
          </select>

        <button
         className='buttonConstruct'
          style={{ marginTop: "10px", padding: "10px", marginLeft: '42px' }}
          onClick={handleCreate}
        >
          Создать
        </button>
      </div>

      {/* Второй блок: Таблица */}
      <div>
        {projects.length > 0 && (
          <table border="1" cellPadding="10" className='results-table'>
            <thead>
              <tr>
                <th>Id</th>
                <th>Название проекта</th>
                <th>Округ</th>
                <th>Регион</th>
                <th>Создал</th>
                <th>Дата создания</th>
                <th>Удаление</th>

              </tr>
            </thead>
            <tbody>
              {projects.map((proj, index) => (
                <tr key={index} onClick={() => openMapProject(proj)}>
                  <td>{proj.id}</td>
                  <td>{proj.name}</td>
                  <td>{proj.canton}</td>
                  <td>{proj.region}</td>
                  <td>{proj.authorId}</td>
                  <td>{new Date(proj.createDate).toLocaleString('sv-SE', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                    }).replace('T', ' ')}</td>
                     <td>
                      <DeleteForeverIcon
                         onClick={(event) => {
                            event.stopPropagation();  // <-- Останавливаем всплытие клика к строке
                            handleDeleteClick(proj.id)
                          }}
                        style={{
                          color: '#d53939',
                          cursor: 'pointer',
                        }}
                      />
                    </td>
                 </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: {
            backgroundColor: '#424242', // темно-серый фон
            color: 'white', // белый текст
            boxShadow: 24, // тень
            borderRadius: 3, // радиус рамки
            p: 2,
          },
        }}
      >
        <DialogTitle style={{color: '#eab33c'}}>Ошибка</DialogTitle>
        <DialogContent>
          <Typography>Заполните название проекта и выберите округ.</Typography>
        </DialogContent>
        <DialogActions>
          <Button class='buttonConstruct' style={{paddingTop: '10px', paddingBottom: '10px', paddingLeft: '20px',paddingRight: '20px'}} onClick={() => setOpen(false)} variant="contained" >
            Ок
          </Button>
        </DialogActions>
      </Dialog>


      <ConfirmDialog
       open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleDeleteProject}
      />
    </div>
  

  );
};

export default ProjectConstructor;